import { UpgradeLink } from "app/components/React/Table/cells/UpgradeLink";
import { UrlCell } from "app/components/React/Table/cells/UrlCell";
import type { FunctionComponent } from "react";
import type { ITableCellProps } from "../interfaces/ITableCellProps";

export const KeywordAnalysisUrl: FunctionComponent<ITableCellProps> = ({ value, row }) => {
    const { Domain } = row;

    return <>{Domain !== "grid.upgrade" ? <UrlCell site={value} /> : <UpgradeLink hookType="website" />}</>;
};
